"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var styles = function styles(theme) {
  var _inner;

  if (!("scrollbars" in theme)) {
    theme.scrollbars = {
      main: {}
    };
  }

  return {
    wrapper: {
      background: theme.palette.background.paper,
      borderTop: "1px solid rgba(0, 0, 0, 0.12)",
      color: "#777",
      flex: "none",
      fontFamily: theme.typography.fontFamily,
      fontSize: "0.8rem"
    },
    inner: (_inner = {}, (0, _defineProperty2.default)(_inner, theme.breakpoints.down("sm"), {
      justifyContent: "center"
    }), (0, _defineProperty2.default)(_inner, "alignItems", "center"), (0, _defineProperty2.default)(_inner, "display", "flex"), (0, _defineProperty2.default)(_inner, "height", "85px"), (0, _defineProperty2.default)(_inner, "padding", "0 4em"), _inner)
  };
};

exports.styles = styles;